import type { UseFormRegisterReturn } from "react-hook-form";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/components/ui";

export interface TextFormFieldProps {
  label?: string;
  type?: HTMLInputElement["type"];
  className?: string;
  register: UseFormRegisterReturn;
  disabled?: boolean;
  placeholder?: string;
  dataTestId?: string;
  handleChange?: (value: string) => void;
  min?: number;
  max?: number;
  maxLength?: number;
}

export const TextFormField = ({
  label,
  type,
  className,
  register,
  disabled,
  placeholder,
  dataTestId,
  handleChange,
  min,
  max,
  maxLength,
}: TextFormFieldProps) => {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      {...register}
      // @ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex">
            {label && <FormLabel>{label}</FormLabel>}
            <FormMessage
              data-testid="error-message"
              className="grow text-right"
            />
          </div>
          <FormControl>
            <Input
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              min={min}
              max={max}
              maxLength={maxLength}
              {...field}
              data-testid={dataTestId}
              onChange={(e) => {
                handleChange?.(e.target.value);
                field.onChange(e);
              }}
            ></Input>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
